export function getPercentageChange(current: number, previous: number): string {
    // Check if either value is not a valid number
    if (
        typeof current !== 'number' ||
        typeof previous !== 'number' ||
        isNaN(current) ||
        isNaN(previous)
    ) {
        return '-';
    }

    if (previous === 0) {
        return current === 0 ? '0%' : '+100%';
    }

    const change = ((current - previous) / previous) * 100;
    const rounded = Math.round(change);

    // Check if the result is NaN
    if (isNaN(rounded)) {
        return '-';
    }

    return `${rounded > 0 ? '+' : ''}${rounded}%`;
}
